import { render } from "./FaultManagementInspector.vue?vue&type=template&id=0f6bd74f"
import script from "./FaultManagementInspector.vue?vue&type=script&lang=js"
export * from "./FaultManagementInspector.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__